const zoneRoleToastState = {
  initial: "toast",
  on: {
    RETRY: { target: "pending", internal: false },
    RETOAST: ".toast"
  },
  states: {
    toast: {
      after: {
        2000: "hidden"
      }
    },
    hidden: {}
  }
}

export default {
  id: "zoneRole",
  initial: "fetchZones",
  states: {
    fetchZones: {
      initial: "loading",
      entry: ["zoneRoleReport"],
      invoke: {
        id: "getZoneInfo",
        src: "getZoneInfo",
        onDone: {
          target: ".loaded",
          actions: ["setZoneList"]
        },
        onError: {
          target: ".failure"
        }
      },
      states: {
        loading: {},
        loaded: {
          always: "#zoneRole.fetchUserZoneId"
        },
        failure: {}
      }
    },
    fetchUserZoneId: {
      initial: "pending",
      states: {
        pending: {
          invoke: {
            id: "getUserZoneId",
            src: "getUserZoneId",
            onDone: {
              target: "success",
              actions: "setZoneIdFromOutside"
            },
            onError: "failure"
          }
        },
        success: {
          always: "#zoneRole.fetchRole"
        },
        failure: {}
      }
    },
    fetchRole: {
      initial: "pending",
      states: {
        pending: {
          invoke: {
            id: "getRoleInfo",
            src: "getRoleInfo",
            onDone: {
              target: "success",
              actions: ["setSelectedZoneFromList", "setSelectedRole", "setPartitionInfoFromRoleInfo", "persistUserZoneRole"]
            },
            onError: {
              target: "failure",
              actions: ["cancelRole", "fetchRoleToast"]
            }
          }
        },
        success: {
          always: "#zoneRole.hasSelectedRole"
        },
        failure: {
          ...zoneRoleToastState
        }
      }
    },
    register: {
      initial: "pending",
      states: {
        pending: {
          invoke: {
            id: "registerTask",
            src: "registerTask",
            onDone: {
              target: "success"
            },
            onError: {
              target: "failure",
              actions: "registerTaskError"
            }
          }
        },
        success: {
          always: "#task.checking"
        },
        failure: {
          ...zoneRoleToastState
        }
      }
    },
    hasSelectedRole: {
      // on: {
      //   CONFIRM_ZONE_ROLE: "register"
      // }
    }
  },
  on: {
    CHANGE_ZONE: {
      target: "#zoneRole.fetchRole",
      actions: "changeZoneIdFromList"
    },
    CONFIRM_REGISTER: {
      target: "#zoneRole.register"
    },
    RETRY_ZONEROLE: {
      target: "#zoneRole"
    }
  }
}
